export default {
    mapsKey: "AIzaSyCc5FjlVhBE2hZkuM1OUbixXGsVXnRwZ4o",
    mapsOtherkey: "AIzaSyDSrNgyDHSkqDzUMNIJEbsLt3u_q1RbjYw"
  };
  